import Form from 'components/Form';
import { IFormValues, IFormRegister, IFormWatch } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SectionTitle from '../../components/SectionTitle';

import VAECMO_1_Row from './components/VAECMO_1_Row';
import VAECMO_1_Column from './components/VAECMO_1_Column';
import FallingCheckbox from './components/FallingCheckbox';
import { Stack } from '@mui/system';
import { Typography } from '@mui/material';

interface Props extends IFormValues, IFormRegister, IFormWatch {
  disabled?: boolean;
}

const TreatmentReasone = (props: Props) => {
  const { disabled, getValues, setValue, register } = props;

  return (
    <>
      <SectionTitle title="2. 시술사유 (적응증)" mb={-5} />
      <RowContainer xs={12}>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <FallingCheckbox
            disabled={disabled}
            i18nKey="ECMO.REASONE.CARDIOGENIC"
            values={[1, 2]}
            defaultValue={getValues('treatment_reason.indications')}
            onChange={v => setValue('treatment_reason.indications', v)}
          />
        </RowContent>

        {/* 박스안의 내용물 */}
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <Stack
            direction="column"
            sx={{
              border: '1px solid #c0bebed4',
              borderRadius: '7px',
              marginTop: '-20px',
              padding: '8px',
            }}
          >
            <Typography
              sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '10px' }}
            >
              가. VA ECMO
            </Typography>
            <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
              1) Cardiogenic shock or impending cardiogenic shock
            </Typography>
            <Stack direction="row">
              <RowContent title="사유" titleRatio={1} childrenRatio={10}>
                <VAECMO_1_Row
                  i18nKey="ECMO.CARDIAC.REASONE"
                  i18nNullKey="ETC"
                  values={[1, 2, 3, 4, 5, 6, 7, 0]}
                  disabled={disabled}
                  register={register}
                  defaultValue={getValues('treatment_reason.va_shock_reason')}
                  onChange={v => {
                    setValue('treatment_reason.va_shock_reason', v);
                  }}
                  width="auto"
                />
              </RowContent>
            </Stack>
            <Stack direction="row">
              <RowContent title="Conditions" titleRatio={1} childrenRatio={11}>
                <VAECMO_1_Column
                  i18nKey="ECMO.VA.REASONE"
                  values={[1, 2, 3]}
                  disabled={disabled}
                  register={register}
                  defaultValue={getValues(
                    'treatment_reason.va_shock_condition'
                  )}
                  onChange={v => {
                    setValue('treatment_reason.va_shock_condition', v);
                  }}
                  width="auto"
                />
              </RowContent>
            </Stack>

            <Typography
              sx={{ fontSize: '12px', fontWeight: 500, marginTop: '30px' }}
            >
              2) Cardiac Arrest (각 단계별 심전도 첨부)
            </Typography>
            <RowContent title="" titleRatio={0} childrenRatio={12}>
              <FallingCheckbox
                disabled={disabled}
                i18nKey="ECMO.REASONE.ARREST"
                values={[1, 2]}
                defaultValue={getValues('treatment_reason.va_arrest')}
                onChange={v => setValue('treatment_reason.va_arrest', v)}
              />
            </RowContent>
            <Stack
              direction="row"
              sx={{ marginTop: '10px', marginBottom: '10px' }}
            >
              <RowContent
                title="Notice time to CPR"
                titleRatio={1.3}
                childrenRatio={4.7}
              >
                <Form.MuiTextField
                  {...register('treatment_reason.va_arrest_input1')}
                  required={false}
                  disabled={disabled}
                  sx={{ paddingRight: '20px' }}
                  InputProps={{ ...Form.adornment('', '분') }}
                />
              </RowContent>
              <RowContent
                title="CPR to ECMO"
                titleRatio={1.3}
                childrenRatio={4.7}
              >
                <Form.MuiTextField
                  {...register('treatment_reason.va_arrest_input2')}
                  required={false}
                  disabled={disabled}
                  InputProps={{ ...Form.adornment('', '분') }}
                />
              </RowContent>
            </Stack>
            <Stack direction="row">
              <RowContent
                title="CPR time to ROSC"
                titleRatio={1.3}
                childrenRatio={4.7}
              >
                <Form.MuiTextField
                  {...register('treatment_reason.va_arrest_input3')}
                  required={false}
                  disabled={disabled}
                  sx={{ paddingRight: '20px' }}
                  InputProps={{ ...Form.adornment('', '분') }}
                />
              </RowContent>
              <RowContent
                title="ROSC to ECMO"
                titleRatio={1.3}
                childrenRatio={4.7}
              >
                <Form.MuiTextField
                  {...register('treatment_reason.va_arrest_input4')}
                  required={false}
                  disabled={disabled}
                  InputProps={{ ...Form.adornment('', '분') }}
                />
              </RowContent>
            </Stack>
            <Typography
              sx={{ fontSize: '12px', fontWeight: 500, marginTop: '30px' }}
            >
              3) Bridge to LVAD or Transplantation
            </Typography>
            <RowContent title="" titleRatio={0} childrenRatio={12}>
              <FallingCheckbox
                disabled={disabled}
                i18nKey="ECMO.REASONE.LVAD"
                values={[1, 2]}
                defaultValue={getValues('treatment_reason.va_arrest_lvad')}
                onChange={v => setValue('treatment_reason.va_arrest_lvad', v)}
              />
            </RowContent>
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                marginTop: '30px',
                marginBottom: '10px',
              }}
            >
              4) 말기암이 아닌 환자에서 shock으로 다음 단계의 치료법을 기대하는
              경우
            </Typography>
            <Stack direction="row">
              <RowContent
                title="shock의 이유 및 상황 설명"
                titleRatio={1.3}
                childrenRatio={10.7}
              >
                <Form.MuiTextField
                  {...register('treatment_reason.va_arrest_reason')}
                  required={false}
                  disabled={disabled}
                  placeholder="추가적인 내용을 적어주세요. "
                />
              </RowContent>
            </Stack>
          </Stack>
        </RowContent>
      </RowContainer>
    </>
  );
};

export default TreatmentReasone;
